import { Role } from '@/models/AccountEnums';

export const isAdvisorRole = (role: Role | undefined): boolean =>
  String(role).toLowerCase() === 'advisor';

export const buildRoleAwarePrefix = (
  role: Role | undefined,
  investorId?: number,
): string => {
  return isAdvisorRole(role) && typeof investorId === 'number'
    ? `/api/advisor/Investors/${String(investorId)}`
    : `/api/${String(role)}`;
};
